module.exports = __webpack_public_path__ + "img/MM_logo.3396fd5f.png";